import axios from "axios"
import { getToken } from "../token/tokenSupplier.service"

//constantes
const headers = {
  "Content-Type": "application/json",
  Authorization: "",
}
export const apiCallExpose = (method, url, json) => {
  return new Promise(async resolve => {
    let token = await getToken(true)
    if (token) {
      headers.Authorization = token.token_type + " " + token.access_token

      axios({
        method: method,
        url: url,
        data: JSON.stringify(json),
        mode: "no-cors",
        crossDomain: true,
        headers: headers,
      })
        .then(res => {
          resolve(res)
        })
        .catch(error => {
          resolve(error)
        })
    } else {
      resolve({
        response: { data: { error: "language.messages.error.noToken" } },
      })
    }
  })
}
